<template>
  <div>
    <!-- :style="{ 'background-image': previewImage ? `url(${previewImage})` : 'url()' }" -->
    <!-- <div
      class="imagePreviewWrapper"
      :style="{
        'background-image': previewImage
          ? `url(${previewImage})`
          : imageUrl.length > 0
          ? `url(${imageUrl})`
          : 'url(' +require('@/assets/images/settings/img-placeholder.png') +')'
      }">
    </div> -->
    <!-- <div class="text-center">
      <small
        class="text-secondary-orange font-semibold cursor-pointer"
        @click="$refs.fileInput.click()"
        >Click to upload picture here</small
      >
      <small
        class="text-primary-blue font-semibold d-block cursor-pointer"
        @click="removeImage"
        >Remove Picture</small
      >
      <small>Please select an image smaller than 1MB.</small>
    </div> -->
    <div v-if="isUploadingImage" class="d-flex justify-content-center py-2">
      <saving-loader :icon-color="'#0253B3'" />
    </div>
    <input
      ref="fileInput"
      type="file"
      @input="pickFile"
      @click="$emit('closeTrigger')"
      accept="file/*"
      class="input"
    />

    <div>
        {{docurl}}
    </div>
  </div>
</template>

<script>
import SavingLoader from "@/components/UI/ButtonSavingLoader";

export default {
  props: {
    imageUrl: {
      required: false,
      default: "",
    },
    docurl: {
      required: false,
      default: "",
    },

    isUploadingImage: {
      required: false,
      default: false,
      type: Boolean,
    },
    triggerUpload: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  components: {
    SavingLoader,
  },
  data() {
    return {
      previewImage: null,
    };
  },
  watch: {
    triggerUpload(val){
      if(val){
        this.$refs.fileInput.click()
      }
    }
  },
  methods: {
    removeImage() {
      this.previewImage = null;
      this.$emit("remove-image");
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0].size > 1048576) {
        this.generateToast(
          "Selected image size is too large. Please upload an image smaller than 1MB!",
          "error"
        );
      } else {
        if (file && file[0]) {
          let reader = new FileReader();
          reader.onload =   (e) => {
              console.log(e.target, "target r")
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(file[0]);
          this.$emit("input", file[0]);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.imagePreviewWrapper {
  position: relative;
  width: 120px;
  height: 120px;
//   border-radius: 50%;
  display: block;
  cursor: pointer;
  background-image: url("../../../assets/images/settings/blank-profile-picture.png");
  // margin: 0 auto;
  background-size: cover;
  background-position: center center;
}
// .file-input {
//   display: none;
// }
</style>
